import React from "react";
import { injectIntl } from "react-intl";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { PYRAMID_COLORS } from "../../constants";
import { getWebImageUrl } from "../../../../../utils/image";

// 把 hex 轉成 rgb
const hexToRgb = hex => {
  const cleaned = hex.replace("#", "");
  const num = parseInt(cleaned, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
};

// 調亮顏色
const lighten = (hex, ratio) => {
  const c = hexToRgb(hex);
  const mix = ch => Math.round(ch + (255 - ch) * ratio);
  return `rgb(${mix(c.r)}, ${mix(c.g)}, ${mix(c.b)})`;
};

// 調暗顏色
const darken = (hex, ratio) => {
  const c = hexToRgb(hex);
  const mix = ch => Math.round(ch * (1 - ratio));
  return `rgb(${mix(c.r)}, ${mix(c.g)}, ${mix(c.b)})`;
};

// 產生垂直漸層（上淺 → 原色 → 下深），營造立體感
const makeGradient = color =>
  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: lighten(color, 0.18) },
    { offset: 0.5, color: color },
    { offset: 1, color: darken(color, 0.12) }
  ]);

const Pyramid = props => {
  const { intl } = props;

  return (
    <ReactEcharts
      option={{
        animationDuration: 2000,
        animationDurationUpdate: 2000,
        graphic: {
          elements: [
            {
              type: "image",
              left: "112.5px",
              top: "15px",
              z: 10,
              style: {
                image: getWebImageUrl("img/financial-pyramid/dice_w.png"),
                width: 25,
                height: 25,
                shadowColor: "rgba(0, 0, 0, 0.3)",
                shadowBlur: 4,
                shadowOffsetY: 2,
                shadowOffsetX: 0
              }
            },
            {
              type: "image",
              left: "112.5px",
              top: "85px",
              z: 10,
              style: {
                image: getWebImageUrl("img/financial-pyramid/investment_w.png"),
                width: 25,
                height: 25,
                shadowColor: "rgba(0, 0, 0, 0.3)",
                shadowBlur: 4,
                shadowOffsetY: 2,
                shadowOffsetX: 0
              }
            },
            {
              type: "image",
              left: "112.5px",
              top: "155px",
              z: 10,
              style: {
                image: getWebImageUrl("img/financial-pyramid/saving_w.png"),
                width: 25,
                height: 25,
                shadowColor: "rgba(0, 0, 0, 0.3)",
                shadowBlur: 4,
                shadowOffsetY: 2,
                shadowOffsetX: 0
              }
            },
            {
              type: "image",
              left: "112.5px",
              top: "245px",
              z: 10,
              style: {
                image: getWebImageUrl("img/financial-pyramid/protection_w.png"),
                width: 25,
                height: 25,
                shadowColor: "rgba(0, 0, 0, 0.3)",
                shadowBlur: 4,
                shadowOffsetY: 2,
                shadowOffsetX: 0
              }
            }
          ]
        },
        series: [
          {
            type: "funnel",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            sort: "ascending",
            gap: 4,
            // 圓角
            itemStyle: {
              borderRadius: 8
            },
            label: {
              show: true,
              position: "inside",
              fontSize: 20,
              fontWeight: "bold",
              fontFamily: "'Roboto', 'Noto Sans TC', sans-serif",
              // 乾淨白色文字加上陰影營造 3D 浮凸感
              color: "#fff",
              textShadowColor: "rgba(0, 0, 0, 0.3)",
              textShadowBlur: 4,
              textShadowOffsetY: 2,
              textShadowOffsetX: 0
            },
            data: [
              {
                value: 20,
                name: intl.formatMessage({ id: "Risk" }),
                itemStyle: {
                  color: makeGradient(PYRAMID_COLORS[0]),
                  height: "23%",
                  borderRadius: 8
                },
                label: {
                  padding: [40, 0, 0, 0]
                }
              },
              {
                value: 40,
                name: intl.formatMessage({ id: "Investment" }),
                itemStyle: {
                  color: makeGradient(PYRAMID_COLORS[1]),
                  height: "23%",
                  borderRadius: 8
                },
                label: {
                  padding: [35, 0, 0, 0]
                }
              },
              {
                value: 60,
                name: intl.formatMessage({ id: "Saving" }),
                itemStyle: {
                  color: makeGradient(PYRAMID_COLORS[2]),
                  height: "23%",
                  borderRadius: 8
                },
                label: {
                  padding: [35, 0, 0, 0]
                }
              },
              {
                value: 60,
                itemStyle: {
                  height: "4%",
                  color: "#f0f9f9"
                }
              },
              {
                value: 60,
                name: intl.formatMessage({ id: "Protection" }),
                itemStyle: {
                  color: makeGradient(PYRAMID_COLORS[3]),
                  height: "22%",
                  borderRadius: 8
                },
                label: {
                  padding: [35, 0, 0, 0]
                }
              }
            ]
          }
        ]
      }}
    />
  );
};

export default injectIntl(Pyramid);
